import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionAnswer } from '../appointment-const/appointmentHistory-model';
import { AssessmentHistoryService } from '../appointment-services/assessment-history.service';
import { QuestionType, QuestionTemplate } from '../../dashboard/components/appoinmnet-Booking/appoinment-const/appoinment-enum';
import { ButtonModule } from 'primeng/button';
import { ImageModule } from 'primeng/image';
import { Router } from '@angular/router';

@Component({
  selector: 'patient-answer-detail',
  standalone: true,
  imports: [CommonModule, ButtonModule, ImageModule],
  templateUrl: './answer-detail.component.html',
  styleUrl: './answer-detail.component.css'
})
export class AnswerDetailComponent implements OnInit {

  assessmentDetails: any = {};
  QuestionNAnswerList: QuestionAnswer[] = [];
  assesmentDetailsService = inject(AssessmentHistoryService);
  private router = inject(Router);

  QuestionType = QuestionType;
  QuestionTemplate = QuestionTemplate;

  constructor() { }

  ngOnInit(): void {
    if (history.state && history.state.assessmentDetails) {
      this.assessmentDetails = history.state.assessmentDetails;
      console.log(this.assessmentDetails, "this state data from route");
      if (this.assessmentDetails.assessmentID) {
        this.getAnswerText(this.assessmentDetails.assessmentID);
      }
    }
  }

  getAnswerText(id: string) {
    this.assesmentDetailsService.getAssessmentDetails(id).subscribe({
      next: (res) => {
        console.log(res);
        this.QuestionNAnswerList = res.questionAnswers || [];
      },
      error: (err) => {
        console.error('Error fetching assessment answers:', err);
      }
    });
  }

  getQuestionTypeText(type: number): string {
    switch (Number(type)) {
      case QuestionType.Single_Choice: return 'Single Choice';
      case QuestionType.Multi_Choice: return 'Multiple Choice';
      case QuestionType.Text: return 'Free Text';
      case QuestionType.Yes_No: return 'Yes / No';
      case QuestionType.File_Upload: return 'File Upload';
      case QuestionType.Progress_Bar: return 'Scale Input';
      case QuestionType.Date: return 'Date';
      case QuestionType.Number: return 'Numeric Input';
      case QuestionType.Dietry_Recall: return 'Dietary Recall';
      default: return 'Question';
    }
  }

  isJSON(str: string): boolean {
    if (!str) return false;
    try {
      const parsed = JSON.parse(str);
      return (typeof parsed === 'object' && parsed !== null);
    } catch (e) {
      return false;
    }
  }

  parseJSON(str: string): any {
    if (!str) return null;
    try {
      return JSON.parse(str);
    } catch (e) {
      return null;
    }
  }

  splitValues(val: string): string[] {
    if (!val) return [];
    if (this.isJSON(val)) {
      const parsed = JSON.parse(val);
      if (Array.isArray(parsed)) return parsed.map(v => String(v));
    }
    return val.split(',').map(v => v.trim()).filter(v => v.length > 0);
  }

  isImageUrl(val: string | null): boolean {
    if (!val) return false;
    const lower = val.split('?')[0].toLowerCase(); // Ignore Azure Blob query params if present
    return lower.endsWith('.png') || lower.endsWith('.jpg') || lower.endsWith('.jpeg') || lower.endsWith('.gif') || lower.endsWith('.webp') || val.includes('blob.core.windows.net');
  }

  parseNumber(val: string | number | undefined | null): number {
    if (val === null || val === undefined) return 0;
    const num = Number(val);
    if (isNaN(num)) return 0;
    return num > 100 ? 100 : (num < 0 ? 0 : num);
  }

  parseDietaryRecall(jsonString: string): any[] {
    if (!jsonString) return [];
    let cleaned = jsonString.trim();
    if (cleaned.startsWith('[')) {
      cleaned = cleaned.substring(1, cleaned.length - 1);
    }

    const meals: any[] = [];
    const mealPattern = /\{meal:\s*([^,}]+),\s*entries:\s*\[([^\]]*)\]\}/g;
    let match;

    while ((match = mealPattern.exec(cleaned)) !== null) {
      const mealName = match[1]?.trim() || '';
      const entriesStr = match[2]?.trim() || '';
      const entries: any[] = [];

      if (entriesStr) {
        const entryPattern = /\{time_range:\s*([^,}]*),\s*start_time:\s*([^,}]*),\s*end_time:\s*([^,}]*),\s*value:\s*([^}]*)\}/g;
        let entryMatch;
        while ((entryMatch = entryPattern.exec(entriesStr)) !== null) {
          const timeRange = entryMatch[1]?.trim() || '';
          const startTime = entryMatch[2]?.trim() || '';
          const endTime = entryMatch[3]?.trim() || '';
          const value = entryMatch[4]?.trim() || '';

          if (value || timeRange || startTime || endTime) {
            entries.push({ time_range: timeRange, start_time: startTime, end_time: endTime, value: value });
          }
        }
      }
      meals.push({ meal: mealName, entries: entries });
    }
    return meals;
  }

  getMealIcon(mealName: string): string {
    const meal = mealName.toLowerCase();
    if (meal.includes('breakfast')) return 'pi-coffee';
    if (meal.includes('lunch')) return 'pi-wallet';
    if (meal.includes('dinner')) return 'pi-moon';
    if (meal.includes('snack')) return 'pi-box';
    if (meal.includes('morning')) return 'pi-sun';
    if (meal.includes('evening')) return 'pi-cloud';
    if (meal.includes('night')) return 'pi-star';
    if (meal.includes('fluid') || meal.includes('beverage')) return 'pi-filter';
    return 'pi-list';
  }

  getMealColorTheme(mealName: string) {
    const meal = mealName.toLowerCase();
    if (meal.includes('breakfast')) return { bg: 'bg-orange-50', text: 'text-orange-600', border: 'border-orange-200', deepText: 'text-orange-800', borderHover: 'hover:border-orange-300', gradient: 'bg-gradient-to-r from-orange-100/60 to-orange-50/20' };
    if (meal.includes('lunch')) return { bg: 'bg-emerald-50', text: 'text-emerald-600', border: 'border-emerald-200', deepText: 'text-emerald-800', borderHover: 'hover:border-emerald-300', gradient: 'bg-gradient-to-r from-emerald-100/60 to-emerald-50/20' };
    if (meal.includes('dinner')) return { bg: 'bg-indigo-50', text: 'text-indigo-600', border: 'border-indigo-200', deepText: 'text-indigo-800', borderHover: 'hover:border-indigo-300', gradient: 'bg-gradient-to-r from-indigo-100/60 to-indigo-50/20' };
    if (meal.includes('snack')) return { bg: 'bg-rose-50', text: 'text-rose-600', border: 'border-rose-200', deepText: 'text-rose-800', borderHover: 'hover:border-rose-300', gradient: 'bg-gradient-to-r from-rose-100/60 to-rose-50/20' };
    if (meal.includes('morning')) return { bg: 'bg-teal-50', text: 'text-teal-600', border: 'border-teal-200', deepText: 'text-teal-800', borderHover: 'hover:border-teal-300', gradient: 'bg-gradient-to-r from-teal-100/60 to-teal-50/20' };
    if (meal.includes('evening')) return { bg: 'bg-purple-50', text: 'text-purple-600', border: 'border-purple-200', deepText: 'text-purple-800', borderHover: 'hover:border-purple-300', gradient: 'bg-gradient-to-r from-purple-100/60 to-purple-50/20' };
    if (meal.includes('night')) return { bg: 'bg-slate-50', text: 'text-slate-600', border: 'border-slate-200', deepText: 'text-slate-800', borderHover: 'hover:border-slate-300', gradient: 'bg-gradient-to-r from-slate-100/60 to-slate-50/20' };
    if (meal.includes('fluid') || meal.includes('beverage')) return { bg: 'bg-cyan-50', text: 'text-cyan-600', border: 'border-cyan-200', deepText: 'text-cyan-800', borderHover: 'hover:border-cyan-300', gradient: 'bg-gradient-to-r from-cyan-100/60 to-cyan-50/20' };
    return { bg: 'bg-gray-50', text: 'text-gray-600', border: 'border-gray-200', deepText: 'text-gray-800', borderHover: 'hover:border-gray-300', gradient: 'bg-gradient-to-r from-gray-100/60 to-gray-50/20' };
  }

  goToScore(){
     this.router.navigateByUrl('create-score', {
      state: {
        assessmentDetails: this.assessmentDetails,
      },
    });
   
  }

  
  goToDiet(){
    const assessmentData = {
      id: this.assessmentDetails.assessmentID,
      patient_id: this.assessmentDetails.patientID,
    };

      this.router.navigateByUrl('diet-list', {
        state: {
          assessment: assessmentData,
        }
      });

  }

}
